/* eslint-disable */
import axios from 'axios';

const request = axios.create({
    baseURL: '',
    timeout: 10000, // Request timeout
});


class Inscription {
  demande(query) {
    return request({
      url: '/api/inscription',
      method: 'post',
      data: query,
    });
  }
  testadresse(query) {
    return request({
      url: '/api/testadresse',
      method: 'post',
      data: query,
    });
  }
  testdemande(query) {
    return request({
      url: '/api/testdemande',
      method: 'post',
      data: query,
    });
  }

}

export { Inscription as default };
